import {
  ADMIN_ALL_TIME_OFF_TYPES,
  ALL_TIME_OFF_STATUSES,
  ALL_TIME_OFF_TYPES,
  ALL_WORKGROUP_DEFAULT_FILTERS,
  DEFAULT_FILTER_SHIFT,
  DEFAULT_FILTER_STATUS,
  LAST_UPDATED,
  SHIFT,
} from "./constants";
import { ONE_YEAR_FROM, TODAY, YESTERDAY } from "./dateHelper";

export const DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER = SHIFT;

export const DEFAULT_TIME_OFF_REQUEST_ADMIN_WORKGROUP_FILTERS = ALL_WORKGROUP_DEFAULT_FILTERS;

export const DEFAULT_EMPLOYEE_TIME_OFF_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};
export const DEFAULT_EMPLOYEE_TIME_OFF_END_DATE_FILTER = (station) => {
  return ONE_YEAR_FROM(station, YESTERDAY(station));
};

export const DEFAULT_ADMIN_TIME_OFF_END_DATE_FILTER = (station) => {
  return TODAY(station);
};

export const DEFAULT_TOR_ADMIN_SORT_MODEL = [
  {
    field: DEFAULT_FILTER_STATUS,
    sort: "asc",
  },
];

export const DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_TYPE_FILTERS = ALL_TIME_OFF_TYPES;

export const DEFAULT_ADMIN_TIME_OFF_REQUEST_TYPE_FILTERS = ADMIN_ALL_TIME_OFF_TYPES;

export const DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_STATUS_FILTERS = ALL_TIME_OFF_STATUSES;

export const DEFAULT_TOR_EMPLOYEE_SORT_MODEL = [
  {
    field: DEFAULT_FILTER_SHIFT,
    sort: "asc",
  },
];

export function filterTimeOffRequests(
  timeOffRequests,
  dateTypeFilter,
  startDateFilter,
  endDateFilter,
  timeOffTypeFilters,
  timeOffStatusFilters,
  workgroup,
  isAdminPage
) {
  let filteredtimeOffRequests = timeOffRequests;
  filteredtimeOffRequests = filterOnDateType(filteredtimeOffRequests, dateTypeFilter, startDateFilter, endDateFilter);
  filteredtimeOffRequests = filterOnTimeOffRequestTypes(filteredtimeOffRequests, timeOffTypeFilters);
  filteredtimeOffRequests = filterOnStatuses(filteredtimeOffRequests, timeOffStatusFilters, isAdminPage);
  filteredtimeOffRequests = filterOnWorkGroup(filteredtimeOffRequests, workgroup, isAdminPage);
  return filteredtimeOffRequests;
}

export function filterOnDateType(filteredTimeOffRequests, dateTypeFilter, startDateFilter, endDateFilter) {
  if (dateTypeFilter) {
    if (dateTypeFilter === LAST_UPDATED) {
      filteredTimeOffRequests = filteredTimeOffRequests.filter(
        (timeOffRequest) =>
          timeOffRequest.lastUpdatedDate.toMillis() >= startDateFilter.toMillis() &&
          timeOffRequest.lastUpdatedDate.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === SHIFT) {
      filteredTimeOffRequests = filteredTimeOffRequests.filter((timeOffRequest) => {
        return (
          timeOffRequest.shiftStart.toMillis() >= startDateFilter.toMillis() &&
          timeOffRequest.shiftStart.toMillis() <= endDateFilter.toMillis()
        );
      });
    }
  }
  return filteredTimeOffRequests;
}

export function filterOnTimeOffRequestTypes(filteredtimeOffRequests, timeOffTypeFilters) {
  if (timeOffTypeFilters) {
    filteredtimeOffRequests = filteredtimeOffRequests.filter((timeOffRequest) =>
      timeOffTypeFilters.includes(timeOffRequest.timeOffRequestType)
    );
  }
  return filteredtimeOffRequests;
}

export function filterOnStatuses(filteredtimeOffRequests, statusFilters) {
  if (statusFilters) {
    filteredtimeOffRequests = filteredtimeOffRequests.filter((timeOffRequest) =>
      statusFilters.includes(timeOffRequest.visibleStatus)
    );
  }
  return filteredtimeOffRequests;
}

export function filterOnWorkGroup(filteredtimeOffRequests, workgroup) {
  if (workgroup) {
    filteredtimeOffRequests = filteredtimeOffRequests.filter((timeOffRequest) =>
      workgroup.includes(timeOffRequest.workgroup)
    );
  }
  return filteredtimeOffRequests;
}
